<template>
    <Head title="Home"/>
    <StoreLayout>
        <div class="isolate py-8">
            <div class="bg-white px-6 py-12 lg:px-8">
                <div class="mx-auto max-w-4xl text-base leading-7 text-gray-700">
                    <div class="rounded-2xl w-full bg-gray-50 p-12 -ml-12  max-w-4xl">
                        <h2 class="text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">Free Shipping
                            Promotion</h2>
                        <ul role="list" class="mt-8 space-y-8 text-gray-600">
                            <li class="flex gap-x-3">
                                <PhTruck class="mt-1 h-5 w-5 flex-none text-indigo-600" aria-hidden="true"/>
                                <span><strong class="font-semibold text-gray-900">United States.</strong> Customers living in the United States receive free standard shipping on all orders of ${{
                                        freeShipping
                                    }} or more.</span>
                            </li>
                            <li class="flex gap-x-3">
                                <PhGlobe class="mt-1 h-5 w-5 flex-none text-indigo-600" aria-hidden="true"/>
                                <span><strong class="font-semibold text-gray-900">International.</strong> International customers receive a $20 immediate credit toward shipping on all orders of ${{
                                        freeShipping
                                    }} or more.</span>
                            </li>
                        </ul>
                        <p class="text-sm mt-4">Offer applies to a single order with a subtotal amount of ${{
                                freeShipping
                            }} or more.</p>
                        <p class="text-sm mt-2">Offer expires December 31, {{
                                roundedDate.toLocaleDateString('en-US', {
                                    year: 'numeric',
                                    month: 'long',
                                    day: 'numeric'
                                })
                            }}.</p>
                    </div>

                    <h2 class="mt-12 text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">Returns Policy</h2>
                    <p class="text-xl mt-10">We want you to be pleased with both your shopping experience and your
                        fabric purchase.</p>
                    <p class="mt-2">Our orders are double-checked before shipment, but if we've made a mistake or if the
                        fabric is
                        defective, please:</p>
                    <ol role="list" class="mt-2 space-y-2 list-inside list-decimal text-gray-600">
                        <li>Call us immediately (or within 15 days) to report the problem. Please have your invoice copy
                            handy when you call 717-768-7101.
                        </li>
                        <li>Allow us to reimburse you for return shipping and give us a chance to correct the mistake or
                            fully refund your order.
                        </li>
                    </ol>

                    <p class="text-xl mt-10">If you've changed your mind about the fabric you ordered, we'll be glad to
                        offer return privileges under these terms:</p>
                    <ol role="list" class="mt-2 space-y-2 list-inside list-decimal text-gray-600">
                        <li>All fabrics must be in the same condition as when you received them.</li>
                        <li>All returns must be made within 15 days of receipt.</li>
                        <li>A 15% restocking fee will apply.</li>
                        <li>Return shipping is your expense.</li>
                        <li>The original cost of the shipping is not refundable.</li>
                    </ol>

                    <h2 class="mt-12 text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">Payment Policy</h2>
                    <p class="text-xl mt-10">We accept Visa, MasterCard, Discover, and American Express.</p>
                    <p class="mt-2">Your credit card will be billed upon shipment of your order.</p>
                    <p class="mt-2">We do not accept checks, cash or money orders.</p>
                    <p class="mt-2">Sales tax of 6% is included for orders shipped to Pennsylvania.</p>

                    <p class="text-xl mt-10">Order Cancellation Fee</p>
                    <p class="mt-2">We reserve the right to apply a $5.00 cancellation fee for any orders cancelled
                        after our processing but prior to shipping.</p>


                    <h2 class="mt-12 text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">Shipping Policy</h2>
                    <p class="text-xl mt-10">Prompt Response and Same-Day Shipping Guarantee!</p>
                    <p class="mt-2">We offers prompt and economical shipping both domestically and internationally.</p>
                    <p class="mt-2">All fabrics are guaranteed to be in-stock and ready for same-day shipment!</p>
                    <p class="mt-2">Monday through Saturday, we guarantee that all orders placed before 1:00 p.m. EST
                        will be shipped the same business day, or your shipping is FREE*.
                        Orders received after 1 p.m. or on Sunday and holidays will be shipped on the next business
                        day.</p>
                    <p class="mt-1 text-sm text-gray-600">*Same-day shipping guarantee applies to orders with authorized
                        payment, and is not valid during holiday promotions.</p>
                </div>
            </div>
        </div>
    </StoreLayout>
</template>

<script setup>
import StoreLayout from "@/Layouts/StoreLayout.vue";
import {Head} from '@inertiajs/vue3';
import {PhTruck, PhGlobe} from "@phosphor-icons/vue";

const props = defineProps({
    freeShipping: Number,
});

function getNextJune30OrDec31() {
    const today = new Date();
    const currentYear = today.getFullYear();

    // Define June 30 and December 31 for the current year
    const june30 = new Date(currentYear, 5, 30); // Month is 0-indexed, so June is 5
    const dec31 = new Date(currentYear, 11, 31); // December is 11

    if (today <= june30) {
        return june30; // Return June 30 if today's date is before or on June 30
    } else {
        return dec31; // Otherwise, return December 31
    }
}

const roundedDate = getNextJune30OrDec31();

</script>
